(function () {
  function init() {
    var cols = document.querySelectorAll('.pp-footer [data-pp-acc]');
    cols.forEach(function (col) {
      var toggle = col.querySelector('[data-pp-acc-toggle]');
      if (!toggle) return;
      toggle.addEventListener('click', function () {
        // Accordion behaviour only applies on mobile (CSS shows panels on desktop)
        if (window.matchMedia('(min-width: 750px)').matches) return;
        var open = col.classList.toggle('is-open');
        toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
